import React from 'react';

import { MenuItem, Select } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';

import { LoyaltyRow, VALID_MULTIPLIERS } from './loyaltyDraft';

export default function LoyaltyMultiplierEditCell({ id, field, value, colDef }: GridRenderEditCellParams<LoyaltyRow>) {
  const apiRef = useGridApiContext();

  return (
    <Select
      autoFocus
      defaultOpen
      fullWidth
      value={value ?? ''}
      inputProps={{ 'aria-label': colDef.headerName }}
      onClose={(event) => {
        if ('key' in event && event.key === 'Escape' && apiRef.current.getCellMode(id, field) === 'edit') {
          event.stopPropagation();
          apiRef.current.stopCellEditMode({ id, field, ignoreModifications: true });
        }
      }}
      onChange={async (event) => {
        const valid = await apiRef.current.setEditCellValue({ id, field, value: Number(event.target.value) });
        // Commit the selection immediately so Save/Search never race a cell waiting for blur.
        if (valid && apiRef.current.getCellMode(id, field) === 'edit') {
          apiRef.current.stopCellEditMode({ id, field });
        }
      }}
    >
      {VALID_MULTIPLIERS.map((multiplier) => (
        <MenuItem key={multiplier} value={multiplier}>
          {multiplier}
        </MenuItem>
      ))}
    </Select>
  );
}
